module.exports = __webpack_public_path__ + "static/media/bottom-cloud.92ab0ead.png";